<template>
    <v-dialog
        v-model="isOpen"
        width="1200"
        v-if="offerDialogOffers"
    >
        <v-card elevation="0">
            <v-card-title>
                <h1 class="display-1 primary--text text-capitalize">Detalle de la oferta</h1>
            </v-card-title>
            <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                            <v-card  elevation="0">
                                <v-card-title><h2 class="font-weight-light">Detalles del Cliente</h2></v-card-title>
                                <v-card-text>
                                    <v-row class="d-flex">
                                        <v-col md="4" cols="12">
                                            <div class="py-4">
                                                <div><strong>Nombre:</strong> {{ offerDialogOffers.header.nombre }} {{ offerDialogOffers.header.apellidos }}</div>
                                                <div><strong>Email:</strong> {{ offerDialogOffers.header.email }}</div>
                                                <div><strong>NIF:</strong> {{ offerDialogOffers.header.nif }}</div>
                                                <div><strong>Fecha Nac.:</strong>{{offerDialogOffers.detail.cliente.fechaNacimiento}}</div>
                                                <div><strong>Estado:</strong> {{ statesIds[offerDialogOffers.header.id_estado]['text'] }} </div>
                                            </div>

                                            <div class="py-4">
                                                <div><strong>Cuota Total Tarifas:</strong> {{ Number(offerDialogOffers.resumen.cuota_total_tarifas).toFixed(2) }} €</div>
                                                <div><strong>Total Descuentos:</strong> {{ offerDialogOffers.resumen.total_descuentos }} €</div>
                                                <div><strong>Cuota Total Terminales:</strong> {{ offerDialogOffers.resumen.cuota_total_terminales }} €</div>
                                                <div><strong>Pago Inicial Terminales:</strong> {{ offerDialogOffers.resumen.pago_inicial_terminales }} €</div>
                                                <div><strong>Pago Sva:</strong> {{ offerDialogOffers.resumen.pago_sva }} €</div>
                                                <div><strong>Pago Mes Sva:</strong> {{ offerDialogOffers.resumen.pago_mes_sva }} €</div>
                                            </div>

                                            <h2><strong>Cuota Mensual:</strong> {{ Number(offerDialogOffers.resumen.cuota_total_tarifas + offerDialogOffers.resumen.total_descuentos).toFixed(2) }} €</h2>
                                        </v-col>
                                        <v-col md="8" cols="12">
                                            <v-alert
                                                outlined
                                                type="error"
                                                prominent
                                                border="left"
                                                class="text-justify"
                                            >
                                                <div class="mb-6">
                                                    <div><strong>ID Cliente:</strong> {{ offerDialogOffers.detail.idVodafone }}</div>
                                                    <div><strong>Oferta SMART:</strong> {{ offerDialogOffers.detail.idOffer }}</div>
                                                    <div><strong>Número de OT:</strong> {{ offerDialogOffers.detail.idOrden }}</div>
                                                </div>

                                                <small>{{ offerDialogOffers.detail.infoPermanencia }}</small>
                                            </v-alert>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="downloadPDF" :style="!$vuetify.breakpoint.smAndDown ? 'position:absolute;bottom:0;right:0;' : ''" class="pa-4">Descargar <v-icon color="green" large>mdi-download</v-icon></v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card elevation="0">
                                    <v-card-title><h2 class="font-weight-light">Productos y Servicios</h2></v-card-title>
                                    <v-card-text>
                                        <v-expansion-panels flat>
                                            <v-expansion-panel v-for="offer, index in offerDialogOffers.detail.offerProductvf" :key="index">
                                                <v-expansion-panel-header
                                                    disable-icon-rotate
                                                    ripple
                                                    color="grey lighten-3"
                                                >
                                                    <p>Paquete <v-icon color="primary" class="">mdi-numeric-{{index+1}}-circle</v-icon></p>
                                                    <template v-slot:actions>
                                                        <v-icon color="primary">
                                                            mdi-package
                                                        </v-icon>
                                                    </template>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-simple-table>
                                                        <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                            <th>Número</th>
                                                            <th>Descripción</th>
                                                            <th>Precio</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="prod, indexProd in offer.offerProductvfDetail">
                                                                <td>
                                                                    {{ sanitizePhoneNumbers(prod) }}
                                                                    <v-tooltip v-if="sanitizePhoneNumbers(prod)" top>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-icon size="18" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                                                        </template>
                                                                        <span>{{ sanitizeOps(prod) }}</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td>{{ prod.catalogOfferDescr }}</td>
                                                                <td>{{ prod.precio }} €</td>
                                                            </tr>
                                                        </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="red"
                    @click="isOpen = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// import OfferDetail from '@/components/RetailX/OfferDetail/OfferDetail.vue';
import statesIds from '@/util/retailX/offerStates.js';

export default {
	name: 'OfferDetailBase',
	data: () => ({
		statesIds,
	}),
	components: {
		// OfferDetail,
	},
	computed: {
		isOpen: {
			get() {
				return this.$store.state.retailX.offerDialog.isOpen;
			},
			set(value) {
				this.$store.commit('retailX/offerDialogOpen', value);
			},
		},
		...mapState('retailX', {
			offerDialogOffers: (state) => state.offerDialog.offers,
			offerDialogIsLoading: (state) => state.offerDialog.isLoading,
		}),
	},
	methods: {
		downloadPDF() {
			this.$store
				.dispatch(
					'retailX/downloadPdfOffer',
					this.offerDialogOffers.detail.offerId
				)
				.then((data) => {
					// const blob = new Blob([data], {
					// 	type: 'application/pdf',
					// });
					// const link = document.createElement('a');
					// link.href = window.URL.createObjectURL(blob);
					// link.download = `oferta_${this.offerDialogOffers.detail.offerId}.pdf`;
					// link.click();
					// open new tab with content html data
					const newWindow = window.open();
					newWindow.document.write(data);
				});
		},
		sanitizePhoneNumbers(prod) {
			let phonenumbers = prod.offerProductvfDetailServices.map(
				(pr) => pr.telefono
			);
			return phonenumbers.filter((it) => it != null).join(', ');
		},
		sanitizeOps(prod) {
			let ops = prod.offerProductvfDetailServices.map(
				(pr) => pr.cfgOperacion?.operacion
			);
			return ops.filter((it) => it != null).join(', ');
		},
	},
};
</script>